export default "__VITE_ASSET__Ck1ho$Z9__"